import { normalize } from "normalizr";
import * as audienceActionTypes from "./types";
import { audienceSchema } from "../../schemas";
import * as ApiConstants from "../../helpers/api";
import { requestWithAuth, requestWithoutAuth } from "../../utils/request";

const API_PATH = `${ApiConstants.getApiUrl()}`;

/*
 Request Audience actions
 */
function requestAudiences() {
    return {
        type: audienceActionTypes.REQUEST_AUDIENCES
    };
}

function successfulRequestAudiences(entities) {
    return {
        type: audienceActionTypes.RECEIVE_AUDIENCES,
        entities
    };
}

function errorRequestAudiences(err) {
    return {
        type: audienceActionTypes.RECEIVE_AUCIENCES_ERROR,
        error: err
    };
}

function parseAudienceResponseData(data) {
    const { audiences } = data;
    const { entities } = normalize(audiences, [audienceSchema]);
    return successfulRequestAudiences(entities);
}

export function fetchAudiences() {
    return dispatch => {
        dispatch(requestAudiences());
        return requestWithAuth(dispatch, http =>
            http.get(`${API_PATH}/audiences`)
        )
            .then(({ data }) => dispatch(parseAudienceResponseData(data)))
            .catch(err => dispatch(errorRequestAudiences(err)));
    };
}

export function fetchAudiencesByShareLink(shareLinkId) {
    return dispatch => {
        dispatch(requestAudiences());
        return requestWithoutAuth(dispatch, http =>
            http.get(`${API_PATH}/wevoShareLinks/${shareLinkId}/audiences`)
        )
            .then(({ data }) => dispatch(parseAudienceResponseData(data)))
            .catch(err => dispatch(errorRequestAudiences(err)));
    };
}



// WEBPACK FOOTER //
// ./src/modules/audiences/actions.js